import { render, staticRenderFns } from "./SavedInputNarratorFriendly.vue?vue&type=template&id=0390481c&scoped=true&"
import script from "./SavedInputNarratorFriendly.vue?vue&type=script&lang=js&"
export * from "./SavedInputNarratorFriendly.vue?vue&type=script&lang=js&"
import style0 from "./SavedInputNarratorFriendly.vue?vue&type=style&index=0&id=0390481c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0390481c",
  null
  
)

export default component.exports